import React, {useEffect} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {useStore} from "../../store";
import {fetchAccount} from "../../store/actions";
import AppBar from "@material-ui/core/AppBar";
import {
    AddPaymentMethod,
    ErrorScreen,
    HeaderToolbar,
    Loading, PaymentMethodCard
} from "../../components";
import Toolbar from "@material-ui/core/Toolbar";
import Card from "@material-ui/core/Card";
import FuseAnimate from "../../components/fuse-animate/fuse-animate";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        marginTop: 16,
        justifyContent: "center",
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        padding: 24,
        width: '100%',
        maxWidth: 340,
        [theme.breakpoints.up('sm')]: {
            maxWidth: 360,
        },
    },
}));

const AddCardPage = ({location}) => {
    const classes = useStyles();
    const [store, dispatch] = useStore();   // Get the global store

    // Scroll to top on mount
    useEffect( () => {
        document.getElementById('psb').scrollTo(0,0);
    }, [])  // <- empty deps means it runs only on load

    // Make sure the account is available in the store
    useEffect(()=> {
        if (store.user.accountId) {
            dispatch(fetchAccount(store.user.accountId, store, dispatch))
        }
    }, [store.user.accountId, store, dispatch])

    return (
        <div id="add-card" className={classes.root}>
            <AppBar position="fixed" className={classes.appBar}>
                <HeaderToolbar location={location.pathname}/>
            </AppBar>
            <Toolbar/>

            <main className={classes.content}>
                { store.account.isFetching ? <Loading/> : null }
                { store.account.error && <ErrorScreen error={store.account.error}/> }
                { store.account.error === null && !store.account.isFetching ?
                    <FuseAnimate animation="transition.expandIn" delay={100}>
                        <div className="flex flex-grow flex-col items-center">
                            <Card className={classes.card}>
                                {store.account.paymentMethod && store.account.paymentMethod.type !== '' ?
                                    <PaymentMethodCard
                                        accountId={store.account.id}
                                        paymentMethod={store.account.paymentMethod}
                                    />
                                    :
                                    <AddPaymentMethod accountId={store.account.id}/>
                                }
                            </Card>
                        </div>
                    </FuseAnimate>
                    : null
                }
            </main>
        </div>
    )

}

export default AddCardPage